import { allCars } from "../../data";
import { Overlay } from "./Overlay";


type WelcomeOverlayProps = {
  onDismissed: () => void;
}

export const WelcomeOverlay: React.FC<WelcomeOverlayProps> = ({onDismissed}: WelcomeOverlayProps) => {
  return (
    <Overlay suffix="Welcome" dismissButtonText="Let's Go!" onDismissed={onDismissed}>
      <h2>Welcome to <strong>Cardle</strong></h2>
      <br/> 
      <h4>Yep, another <a href="https://www.nytimes.com/games/wordle/index.html" target="_blank" rel="noreferrer">Wordle</a> clone. This time, you have <strong>five tries</strong> to deduce the make and model of a <strong>car available in 2022</strong>.</h4>
      <br/>
      <ul>
        <li>A car must be on sale in <strong>10+ countries</strong> to be eligible</li>
        <li>There are currently <strong>{allCars.length} cars</strong> to choose from</li>
        <li>There's a new <strong>Cardle</strong> each day</li>
      </ul>
      <br/>
      <h4>Click/tap on a column heading or a box for help!</h4>
      <br/>
    </Overlay>
  )
}